export default __webpack_public_path__ + "static/media/home8.98d00696.png";